module.exports = __webpack_public_path__ + "static/media/2026_WA-Footy-Lives-Here-Banner-Desktop-@1x.907fbf65.webp";